import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useGrowl } from "PFApp/use_growl";
import { fetchAccount } from "PFCore/services/features";

import { queryKeys } from "../features/query_keys";

type UseAccount = {
  accountId: number;
};

export const useAccount = ({ accountId }: UseAccount) => {
  const growl = useGrowl();
  return useQuery<{ name: string }>(queryKeys.account(accountId), async () => await fetchAccount(accountId), {
    onError: (error: AxiosError) => {
      growl({
        message: error.message,
        kind: "error"
      });
    }
  });
};
